"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _Collections = _interopRequireDefault(require("../../../../java/util/Collections"));

var _DirectedEdge = _interopRequireDefault(require("./DirectedEdge"));

var _ArrayList = _interopRequireDefault(require("../../../../java/util/ArrayList"));

var _Edge = _interopRequireDefault(require("./Edge"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

var DirectedEdgeStar =
/*#__PURE__*/
function () {
  function DirectedEdgeStar() {
    _classCallCheck(this, DirectedEdgeStar);

    DirectedEdgeStar.constructor_.apply(this, arguments);
  }

  _createClass(DirectedEdgeStar, [{
    key: "getNextEdge",
    value: function getNextEdge(dirEdge) {
      var i = this.getIndex(dirEdge);
      return this._outEdges.get(this.getIndex(i + 1));
    }
  }, {
    key: "getCoordinate",
    value: function getCoordinate() {
      var it = this.iterator();
      if (!it.hasNext()) return null;
      var e = it.next();
      return e.getCoordinate();
    }
  }, {
    key: "iterator",
    value: function iterator() {
      this.sortEdges();
      return this._outEdges.iterator();
    }
  }, {
    key: "sortEdges",
    value: function sortEdges() {
      if (!this._sorted) {
        _Collections.default.sort(this._outEdges);

        this._sorted = true;
      }
    }
  }, {
    key: "remove",
    value: function remove(de) {
      this._outEdges.remove(de);
    }
  }, {
    key: "getEdges",
    value: function getEdges() {
      this.sortEdges();
      return this._outEdges;
    }
  }, {
    key: "getNextCWEdge",
    value: function getNextCWEdge(dirEdge) {
      var i = this.getIndex(dirEdge);
      return this._outEdges.get(this.getIndex(i - 1));
    }
  }, {
    key: "getIndex",
    value: function getIndex() {
      if (arguments[0] instanceof _Edge.default) {
        var edge = arguments[0];
        this.sortEdges();

        for (var i = 0; i < this._outEdges.size(); i++) {
          var de = this._outEdges.get(i);

          if (de.getEdge() === edge) return i;
        }

        return -1;
      } else if (arguments[0] instanceof _DirectedEdge.default) {
        var dirEdge = arguments[0];
        this.sortEdges();

        for (var i = 0; i < this._outEdges.size(); i++) {
          var de = this._outEdges.get(i);

          if (de === dirEdge) return i;
        }

        return -1;
      } else if (Number.isInteger(arguments[0])) {
        var _i = arguments[0];

        var modi = _i % this._outEdges.size();

        if (modi < 0) modi += this._outEdges.size();
        return modi;
      }
    }
  }, {
    key: "add",
    value: function add(de) {
      this._outEdges.add(de);

      this._sorted = false;
    }
  }, {
    key: "getDegree",
    value: function getDegree() {
      return this._outEdges.size();
    }
  }, {
    key: "getClass",
    value: function getClass() {
      return DirectedEdgeStar;
    }
  }, {
    key: "interfaces_",
    get: function get() {
      return [];
    }
  }]);

  return DirectedEdgeStar;
}();

exports.default = DirectedEdgeStar;

DirectedEdgeStar.constructor_ = function () {
  this._outEdges = new _ArrayList.default();
  this._sorted = false;
};